document.addEventListener('DOMContentLoaded', () => {
  
  const productListBtns = document.querySelectorAll('.product-list-switch__btn input'),
        productGrids = document.querySelectorAll('.product-list-grid'),
        gridsContainer = document.querySelector('.product-list__container');

  productListBtns.forEach( (btn,i,allBtns) => {

    btn.addEventListener('input', (event) => { 
      disableBtns();
      initGridAnimations(productGrids[i], i);
      addHeightToContainer(gridsContainer);
    }, false)


  });

  function initGridAnimations(gridToShow, indexToShow) {

    let visibleGrid = document.querySelector('.product-list-grid.visible');

    hideGrid(visibleGrid);

    function hideGrid(grid) {
      grid.classList.remove('fadeIn', 'visible');
      grid.classList.add('fadeOut');
      showGrid();
    }
    
    function showGrid(){
      gridToShow.classList.remove('fadeOut');
      gridToShow.classList.add('fadeIn', 'visible');
    }

    gridToShow.addEventListener('animationend', () => enableBtns() );
  };

  function disableBtns(){
    productListBtns.forEach( btn => {
      btn.setAttribute('disabled', '');
    } )
  }

  function enableBtns() {
    productListBtns.forEach( btn => {
      btn.removeAttribute('disabled', '');
    } )
  }

  function addHeightToContainer(container){
    container.style.minHeight = `${container.clientHeight}px`;
  }


});
